import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";
import { RECAPTCHA_SITE_KEY } from "shared/util/constants";
import ReCAPTCHA from "react-google-recaptcha";

import "./Captcha.scss";

const Captcha = (props) => {
	return (
		<div className="signup2017-recaptcha">
			<div className="signup2017-recaptcha-container">
				{!props.captchaValue &&
					<Str className="signup2017-recaptcha-label">
						Prove you’re human
					</Str>
				}

				<ReCAPTCHA
					sitekey={RECAPTCHA_SITE_KEY}
					onChange={props.onVerify}
				/>
			</div>
		</div>
	);
};

Captcha.propTypes = {
	onVerify: PropTypes.func.isRequired,
	captchaValue: PropTypes.string.isRequired,
};

export default Captcha;



// WEBPACK FOOTER //
// ./src/apps/signup/components/Registration/Captcha.jsx